export const environment = {
    production: false,
    apiURL: "https://api.adminapp-dev.flaxandkale.com"
};